class exports.HybridOption

    id: null
    isRefuge: false
    # refuge_options: []

    constructor: (hybrid, hybridsTaffy, isRefuge = false, refuge_options = null) ->
        if not (hybrid? and hybrid instanceof Object)
            return @error 'No hybrid given.', hybrid

        # hybrid ID
        if hybrid.hybridID? and parseInt hybrid.hybridID
            @id = parseInt hybrid.hybridID
        else if hybrid.id? and parseInt hybrid.id
            @id = parseInt hybrid.id
        else if hybrid.hybrids_id? and parseInt hybrid.hybrids_id
            @id = parseInt hybrid.hybrids_id
        else if hybrid.refuge_hybrids_id? and parseInt hybrid.refuge_hybrids_id
            @id = parseInt hybrid.refuge_hybrids_id
        else
            return @error 'No hybrid ID given.', hybrid

        # hybrids taffy
        if not (hybridsTaffy? and hybridsTaffy instanceof Function)
            return @error 'No hybrids taffy table given.', hybridsTaffy

        # additional hybrid info (from SPP-specific hybrid info query)
        hybrid = $.extend( {}, hybrid, hybridsTaffy( id: @id ).first() )
        for key, val of hybrid
            if key in ['id']
                continue

            # if key is 'display_name' and not @hybridName
            #     @hybridName = val

            @[key] = val

        @isRefuge = isRefuge

        # refuge options
        if not @isRefuge
            if hybrid.refuge_options? and hybrid.refuge_options instanceof Array
                temp_refuge_options = hybrid.refuge_options
            else if refuge_options? and refuge_options instanceof Array
                temp_refuge_options = refuge_options
            else
                return @error 'No refuge options given.', hybrid

            @refuge_options = []
            for refuge in temp_refuge_options
                ro = new HybridOption(refuge, hybridsTaffy, true)
                if ro? then @refuge_options.push ro


    get: () ->
        obj = {}
        for key, val of this
            if key in ['__proto__', 'id'] or val instanceof Function
                continue
            else if key is 'refuge_options'
                arr = []
                for ro in val
                    arr.push ro.get()
                obj['refuge_options'] = arr
            else
                obj[key] = val
        return obj


    error: (msg, obj = null) ->
        debugLog 'Failed to create HybridOption object. ' + msg
        debugLog obj if obj?
        return null
